export type AddressDisplayParts = {
  street?: string | null;
  postalCode?: string | null;
  city?: string | null;
  provinceCode?: string | null;
};

export const formatStreetLine = ({
  street,
  streetNumber,
}: {
  street: string;
  streetNumber: string;
}) => [street, streetNumber].filter(Boolean).join(', ');

export const formatAddress = ({
  street,
  postalCode,
  city,
  provinceCode,
}: AddressDisplayParts) => {
  const locality = [postalCode, city].filter(Boolean).join(' ');
  const place = provinceCode ? `${locality} (${provinceCode})` : locality;
  return [street, place.trim()].filter(Boolean).join(', ');
};
